import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";

export function CoinStreak() {
  const [streak, setStreak] = useState(0);
  const [best, setBest] = useState(0);
  const [coin, setCoin] = useState(null);
  const [over, setOver] = useState(false);
  const [flipping, setFlipping] = useState(false);

  const flip = (call) => {
    if (flipping || over) return;
    setFlipping(true);
    setTimeout(() => {
      const r = Math.random() < 0.5 ? "H" : "T";
      setCoin(r);
      if (r === call) { const s = streak + 1; setStreak(s); setBest((b) => Math.max(b, s)); }
      else { setOver(true); }
      setFlipping(false);
    }, 500);
  };

  const reset = () => { setStreak(0); setCoin(null); setOver(false); };

  return (
    <div className="flex flex-col items-center text-center" data-testid="coin-streak">
      <div className="flex gap-6 mb-4 font-mono">
        <span className="text-neon-cyan text-lg" data-testid="coin-streak-val">STREAK: {streak}</span>
        <span className="text-neon-yellow text-lg">BEST: {best}</span>
      </div>
      <div className={`w-32 h-32 rounded-full flex items-center justify-center font-display font-black text-5xl mb-6 ${flipping ? "animate-spin" : ""}`}
        style={{ background: coin === "H" ? "#EFFF04" : coin === "T" ? "#00F0FF" : "#3f3f46", color: "#000" }} data-testid="coin-face">
        {flipping ? "?" : coin || "🪙"}
      </div>
      {over ? (
        <>
          <p className="font-display font-black text-xl text-neon-pink uppercase mb-3" data-testid="coin-over">Wrong! Streak ended at {streak}</p>
          <Button onClick={reset} className="bg-neon-cyan text-black rounded-none font-bold uppercase"><RotateCcw className="w-4 h-4 mr-1" /> Try Again</Button>
        </>
      ) : (
        <div className="flex gap-3">
          <Button onClick={() => flip("H")} data-testid="coin-heads" disabled={flipping} className="bg-neon-yellow text-black rounded-none font-bold uppercase">Heads</Button>
          <Button onClick={() => flip("T")} data-testid="coin-tails" disabled={flipping} className="bg-neon-cyan text-black rounded-none font-bold uppercase">Tails</Button>
        </div>
      )}
      <p className="text-zinc-500 text-xs font-mono mt-4">Call the coin right to build a streak. One wrong call ends it!</p>
    </div>
  );
}
